import { SxProps, Theme } from '@mui/material';

import { drawerWidthClose } from './components/NavigationDrawer/NavigationDrawer.styles';

export const stylesMainLayout = {
  display: 'flex',
};
export const stylesMain = {
  flexGrow: 1,
  p: 3,
};

export const stylesMainContent = {
  ml: `${drawerWidthClose}px`,
  height: '100vh',
  width: '100%',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  zIndex: 0,
};
export const stylesMainContentBody = { flex: 1, overflow: 'auto', px: 4 };

export const underlineText: SxProps<Theme> = { textDecoration: 'underline' };
